import { createEngine, type Engine } from './engine';

let singleton: Engine | null = null;

/**
 * Creates the checklist engine once and publishes the machine-facing subset as
 * `window.ZW_CHECKLIST`. Called from the page component, so opening any other
 * dashboard route installs nothing.
 */
export function getEngine(): Engine {
  if (singleton) return singleton;
  const engine = createEngine();
  singleton = engine;
  (window as any).ZW_CHECKLIST = {
    version: engine.version,
    pageRevision: engine.pageRevision,
    meta: engine.meta,
    runAuto: () => engine.runAuto(),
    runAll: () => engine.runAll(),
    run: (id: string) => engine.run(id),
    results: () => engine.results(),
    reset: () => engine.reset(),
    resumeState: () => engine.resumeState(),
    onComplete: (cb: (r: Record<string, unknown>) => void) => engine.onComplete(cb as any),
  };
  return engine;
}
